import React from "react";
import { Link } from "react-router-dom";
import { Heart, BookOpen, Shield, Smiley } from "@phosphor-icons/react";

const PILLARS = [
  { icon: Heart, title: "Love, not direction", body: "New parents need your love and presence — not your decisions. Listen first. Suggest gently. Cherish your role." },
  { icon: BookOpen, title: "Then vs. now", body: "Vaccination science has evolved. Sleep guidelines too. Honour your wisdom AND embrace new evidence." },
  { icon: Shield, title: "Safe sleep", body: "Babies sleep on their backs, in a clear cot, no pillows or loose blankets. Always. This is the single most important change." },
  { icon: Smiley, title: "Family traditions", body: "Bring the rituals — namkaran, oil massages, lori. These weave a child into a lineage." },
];

const CHECKLIST = [
  "Prepare a calm, clean welcome-home space",
  "Cook for the new mother for the first 40 days",
  "Honour her sleep — visitors during baby's wake windows only",
  "Bring stories about the parents from their own babyhood",
  "Photograph the family — you've done this before",
  "Hold the baby skin-to-skin. They will remember the warmth.",
];

export default function GrandparentMode() {
  return (
    <div className="space-y-10" data-testid="grandparent-mode-page">
      <header>
        <p className="overline text-saffron mb-2">Grandparent mode</p>
        <h1 className="font-serif font-semibold text-4xl sm:text-5xl">A new generation arrives.</h1>
        <p className="text-ink-700 mt-2 max-w-2xl">You've done this before — and yet, never quite like this. Here's how to support, when to step back, and how to leave a legacy of love.</p>
      </header>

      <section data-testid="grandparent-pillars">
        <h2 className="font-serif text-3xl mb-6">Four pillars</h2>
        <div className="grid sm:grid-cols-2 gap-6">
          {PILLARS.map((p) => (
            <div key={p.title} className="vansha-card p-6" data-testid={`gp-pillar-${p.title.toLowerCase().replace(/[\s,]+/g, '-')}`}>
              <p.icon weight="thin" size={28} className="text-terracotta mb-3" />
              <h3 className="font-serif text-xl">{p.title}</h3>
              <p className="text-ink-700 mt-2">{p.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section data-testid="gp-checklist">
        <h2 className="font-serif text-3xl mb-6">How you can help</h2>
        <div className="vansha-card p-8">
          <ul className="space-y-3">
            {CHECKLIST.map((c, i) => (
              <li key={i} className="flex gap-3 text-ink-900" data-testid={`gp-help-${i}`}>
                <span className="text-saffron">·</span>{c}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="grid sm:grid-cols-2 gap-6">
        <Link to="/app/academy/k6" className="vansha-card p-6 hover:shadow-lg transition" data-testid="gp-academy">
          <p className="overline text-saffron mb-2">Learn</p>
          <h3 className="font-serif text-2xl">The Grandparent's Guide</h3>
          <p className="text-ink-700 mt-2 text-sm">25 minutes of modern wisdom for the elder generation.</p>
        </Link>
        <Link to="/app/letters" className="vansha-card p-6 hover:shadow-lg transition" data-testid="gp-letters">
          <p className="overline text-saffron mb-2">Leave your blessing</p>
          <h3 className="font-serif text-2xl">Write a letter</h3>
          <p className="text-ink-700 mt-2 text-sm">Words from a grandparent become a child's heirloom.</p>
        </Link>
      </section>
    </div>
  );
}
